(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ecru-horizontal-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ecru-horizontal-rail')) {
    customElements.define('ecru-horizontal-rail', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        clearInterval(this.autoTimer);
        this.intersection?.disconnect();
        this.resize?.disconnect();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const rail = this.querySelector('[data-rail]');
        const controls = this.querySelector('[data-rail-controls]');
        if (!rail || !controls) return;
        const previous = controls.querySelector('[data-rail-prev]');
        const next = controls.querySelector('[data-rail-next]');
        const direction = () => getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
        const update = () => {
          const max = rail.scrollWidth - rail.clientWidth;
          const pos = Math.abs(rail.scrollLeft);
          controls.hidden = max < 4;
          previous.disabled = pos < 4;
          next.disabled = pos > max - 4;
        };
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let reducedByChoice = false;
        try { reducedByChoice = localStorage.getItem('ecru-reduce-motion') === 'true'; } catch (error) {}
        let holdUntil = 0;
        const hold = () => { holdUntil = performance.now() + 8000; };
        document.addEventListener('ecru:motion-preference', event => { reducedByChoice = event.detail.reduce; hold(); }, {signal});
        const move = step => rail.scrollBy({left: step * direction() * rail.clientWidth * .8, behavior: (motion.matches || reducedByChoice) ? 'instant' : 'smooth'});
        previous.addEventListener('click', () => { hold(); move(-1); }, {signal});
        next.addEventListener('click', () => { hold(); move(1); }, {signal});
        rail.addEventListener('scroll', update, {signal, passive: true});
        rail.addEventListener('keydown', e => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
          e.preventDefault();
          hold();
          if (e.key === 'Home' || e.key === 'End') rail.scrollTo({left: e.key === 'Home' ? 0 : direction() * rail.scrollWidth, behavior: 'instant'});
          else move((e.key === 'ArrowRight' ? 1 : -1) * direction());
        }, {signal});
        let pointer = null;
        let suppressClick = false;
        rail.addEventListener('dragstart', e => e.preventDefault(), {signal});
        rail.addEventListener('pointerdown', e => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          pointer = {id: e.pointerId, x: e.clientX, scroll: rail.scrollLeft};
          suppressClick = false;
        }, {signal});
        rail.addEventListener('pointermove', e => {
          if (!pointer || e.pointerId !== pointer.id) return;
          const delta = e.clientX - pointer.x;
          if (Math.abs(delta) < 6 && !suppressClick) return;
          if (!suppressClick) rail.setPointerCapture(e.pointerId);
          suppressClick = true;
          rail.setAttribute('data-dragging', '');
          rail.scrollLeft = pointer.scroll - delta;
        }, {signal});
        const finish = () => {
          if (pointer && rail.hasPointerCapture(pointer.id)) rail.releasePointerCapture(pointer.id);
          pointer = null;
          rail.removeAttribute('data-dragging');
          update();
        };
        rail.addEventListener('pointerup', finish, {signal});
        rail.addEventListener('pointercancel', finish, {signal});
        rail.addEventListener('lostpointercapture', finish, {signal});
        rail.addEventListener('pointerleave', () => { if (!suppressClick) pointer = null; }, {signal});
        rail.addEventListener('click', e => { if (suppressClick) {e.preventDefault(); e.stopPropagation(); suppressClick = false;} }, {signal, capture: true});
        if (this.hasAttribute('data-auto-advance')) {
          let visible = false, hover = false, focused = false, touching = false, step = 1;
          this.intersection = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, {threshold: .35});
          this.intersection.observe(rail);
          this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hover = true; }, {signal});
          this.addEventListener('pointerleave', () => { hover = false; hold(); }, {signal});
          this.addEventListener('focusin', () => { focused = true; }, {signal});
          this.addEventListener('focusout', event => { focused = this.contains(event.relatedTarget); hold(); }, {signal});
          rail.addEventListener('pointerdown', () => { touching = true; hold(); }, {signal, passive: true});
          const release = () => { touching = false; hold(); };
          window.addEventListener('pointerup', release, {signal, passive: true});
          window.addEventListener('pointercancel', release, {signal, passive: true});
          rail.addEventListener('wheel', hold, {signal, passive: true});
          rail.addEventListener('touchend', release, {signal, passive: true});
          this.autoTimer = setInterval(() => {
            if (!visible || hover || focused || touching || motion.matches || reducedByChoice || document.hidden || performance.now() < holdUntil) return;
            const max = rail.scrollWidth - rail.clientWidth;
            if (max < 4) return;
            const pos = Math.abs(rail.scrollLeft);
            if (pos >= max - 4) step = -1;
            else if (pos < 4) step = 1;
            const card = rail.firstElementChild;
            if (!card) return;
            const distance = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0);
            rail.scrollBy({left: step * direction() * distance, behavior: 'smooth'});
          }, 4800);
        }
        this.resize = new ResizeObserver(update);
        this.resize.observe(rail);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.intersection?.disconnect(); clearInterval(this.autoTimer); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ecru-motion-preference"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ecru-motion-preference')) {
    customElements.define('ecru-motion-preference', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const input = this.querySelector('input');
        if (!input) return;
        try { input.checked = localStorage.getItem('ecru-reduce-motion') === 'true'; } catch (error) { input.checked = false; }
        this.hidden = false;
        input.addEventListener('change', () => {
          try { localStorage.setItem('ecru-reduce-motion', String(input.checked)); } catch (error) {}
          document.dispatchEvent(new CustomEvent('ecru:motion-preference', {detail: {reduce: input.checked}}));
        }, {signal: this.abort.signal});
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ecrue-price-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ecrue-price-offer')) {
  customElements.define('ecrue-price-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.root = this.closest('.shopify-section');
      this.form = this.root?.querySelector('form[action$="/cart/add"]');
      this.price = Number(this.dataset.price);
      this.available = this.dataset.available === 'true';
      this.onQuantity = () => queueMicrotask(() => this.update());
      this.form?.addEventListener('input', this.onQuantity);
      this.form?.addEventListener('change', this.onQuantity);
      this.form?.addEventListener('click', this.onQuantity);
      this.onVariant = event => {
        if (!this.root?.contains(event.currentTarget)) return;
        const variant = event.currentVariant;
        this.available = !!variant?.available;
        if (variant) this.price = Number(variant.price);
        this.update();
      };
      this.bindTheme = () => {
        if (this.themeBound || !window.jQuery_T4NT) return;
        this.themeBound = true;
        window.jQuery_T4NT(document).on('variant:changed.ecrueOfferPreview', '[data-product-featured]', this.onVariant);
        if (this.form) window.jQuery_T4NT(this.form).on('change.ecrueOfferPreview', '[name="quantity"]', this.onQuantity);
      };
      this.bindTheme();
      window.addEventListener('load', this.bindTheme, {once:true});
      this.update();
    }
    update() {
      const quantityInput = this.form?.querySelector('[name="quantity"]');
      const raw = Number(quantityInput?.value || 1);
      const validQuantity = !quantityInput || quantityInput.validity.valid;
      const quantity = Number.isFinite(raw) ? Math.max(1, Math.floor(raw)) : 1;
      const subtotal = this.price * quantity;
      const rate = subtotal >= 3500000 ? 10 : subtotal >= 1000000 ? 5 : 0;
      const tierSavings = Math.round(subtotal * rate / 100);
      const perfumeSavings = this.dataset.perfume === 'true' ? Math.round(Math.floor(quantity / 2) * this.price * .5) : 0;
      const savings = Math.max(tierSavings, perfumeSavings);
      const row = this.querySelector('[data-offer-row]');
      row.hidden = !this.available || !validQuantity || !Number.isFinite(subtotal) || savings <= 0;
      const format = value => new Intl.NumberFormat('en-EG', {style:'currency',currency:'EGP',minimumFractionDigits:0,maximumFractionDigits:2}).format(value / 100);
      this.querySelector('[data-offer-amount]').textContent = format(subtotal - savings);
      this.querySelector('[data-offer-saving]').textContent = format(savings);
    }
    disconnectedCallback() {
      this.form?.removeEventListener('input',this.onQuantity);
      this.form?.removeEventListener('change',this.onQuantity);
      this.form?.removeEventListener('click',this.onQuantity);
      window.removeEventListener('load',this.bindTheme);
      if (window.jQuery_T4NT) {
        window.jQuery_T4NT(document).off('variant:changed.ecrueOfferPreview','[data-product-featured]',this.onVariant);
        if (this.form) window.jQuery_T4NT(this.form).off('change.ecrueOfferPreview','[name="quantity"]',this.onQuantity);
      }
      this.themeBound = false;
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
